module.exports = __webpack_public_path__ + "img/cloud-download-outline.png";